import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'p-tabPanel',
  template: `
    <div class="p-tabview-panel" [hidden]="!selected" role="tabpanel">
      <ng-content></ng-content>
    </div>
  `,
})
export class LegacyTabPanelComponent {
  @Input() header = '';
  @Input() closable = false;
  @Input() disabled = false;
  @Input() selected = false;
}
